export default __webpack_public_path__ + "static/media/email-icon.c7fb7e02.svg";